/* Native Shopify bundle IDs only. Price, discounts and stock are enforced by Shopify. */
(() => {
  if (customElements.get('gh-bundle-picker')) return;
  class HauntedBundlePicker extends HTMLElement {
    connectedCallback() {
      this.clock = Number(this.dataset.serverNow) * 1000;
      this.loaded = performance.now();
      this.start = Number(this.dataset.start) * 1000;
      this.end = Number(this.dataset.end) * 1000;
      this.options = [...this.querySelectorAll('[data-ghb-option]')];
      this.variantInput = this.querySelector('[data-ghb-variant]');
      this.button = this.querySelector('[data-ghb-submit]');
      this.status = this.querySelector('[data-ghb-status]');
      this.form = this.querySelector('form');
      try {
        this.strings = JSON.parse(this.querySelector('[data-ghb-strings]').textContent);
        this.variants = JSON.parse(this.querySelector('[data-ghb-variants]')?.textContent || '[]');
      } catch { this.variants = []; this.strings = {}; }
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.options.forEach(option => option.addEventListener('change', () => this.update(true), {signal}));
      this.form?.addEventListener('submit', event => {
        if (!this.update(true)) event.preventDefault();
      }, {signal});
      document.addEventListener('visibilitychange', () => this.tick(), {signal});
      window.addEventListener('pageshow', () => this.tick(), {signal});
      this.tick();
    }
    disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); }
    now() { return this.clock + performance.now() - this.loaded; }
    campaignOpen() { return this.now() >= this.start && this.now() < this.end; }
    selectedVariant() {
      const selected = this.options.map(option => option.value);
      if (selected.some(value => !value)) return null;
      return this.variants.find(variant => variant.options.length === selected.length && variant.options.every((value, index) => value === selected[index])) || null;
    }
    update(announce = false) {
      const selected = this.options.map(option => option.value);
      if (!this.form) {
        if (announce) this.status.textContent = selected.every(Boolean) ? `${this.strings.selected}: ${selected.join(' / ')}. ${this.strings.preview}` : this.strings.choose;
        return false;
      }
      const variant = this.selectedVariant();
      const open = this.campaignOpen() && this.dataset.purchasable === 'true';
      const ready = open && Boolean(variant?.available);
      this.variantInput.disabled = !ready;
      this.variantInput.value = ready ? String(variant.id) : '';
      this.button.disabled = !ready;
      const copy = !open ? this.strings.closed : selected.some(value => !value) ? this.strings.choose : !variant?.available ? this.strings.unavailable : this.strings.ready;
      // Keep the original inline SVG arrow; never inject variant or server HTML.
      this.button.childNodes[0].textContent = `${copy} `;
      if (announce || !open) this.status.textContent = copy;
      return ready;
    }
    tick() {
      clearTimeout(this.timer);
      this.update();
      if (this.now() >= this.end) {
        this.querySelectorAll('button,select').forEach(control => { control.disabled = true; });
        this.status.textContent = this.strings.closed;
        const card = this.closest('.ghb-card, .ghb-product');
        card?.querySelectorAll('.ghb-price,.ghb-value,.ghb-offer-note').forEach(node => { node.hidden = true; });
        return;
      }
      if (!document.hidden) this.timer = setTimeout(() => this.tick(), Math.min(30000, this.end - this.now()));
    }
  }
  customElements.define('gh-bundle-picker', HauntedBundlePicker);
})();
